



































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatDateForHumanSpecies } from '@/utils/time';

@Component
export default class DateField extends Vue {
  menu = false;

  @Prop({
    default: null,
  })
  allowedDates!: void;

  @Prop()
  label!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) readonly disabled!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly clearButton!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly clearable!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly dense!: boolean

  @Prop({
    type: Boolean,
    default: false,
  }) readonly hideDetails!: boolean

  @Prop({
    type: Boolean,
    default: true,
  }) readonly changeOnButton!: boolean

  @Prop()
  value!: string;

  @Prop({ default: '' })
  defaultValue!: string;

  @Prop()
  errorMessages!: Array<string> | string;

  get date() {
    const date = this.value ? formatDateForHumanSpecies(this.value) : '';

    return date;
  }

  set date(value: string) {
    this.$emit('input', value);
  }

  input(date: any) {
    this.$emit('input', date);
    if (!this.changeOnButton) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.$refs.menu.save(date);
    }
  }

  clearDate() {
    this.$emit('change', '');
    this.$emit('input', '');
  }

  created() {
    if (this.defaultValue) this.$emit('input', this.defaultValue);
  }
}
